import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import messaging from "../../services/messagingv2.js";

class JobbleheaderController {
  constructor(
    $http,
    $localStorage,
    $state,
    AuthService,
    SecurityService,
    TrackingService,
    $rootScope,
    $scope,
    $location,
    $timeout,
    $window,
    $companies,
    Messagingv2Service,
    EventsService
  ) {
    this.name = "jobbleheader";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$security = SecurityService;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$events = EventsService;
    this.$scope = $scope;
    this.showJobsDropDown = false;
    this.$tracking = TrackingService;
    this.$messagingv2 = Messagingv2Service;
    this.$companies = $companies;
    console.log("what is local storage at this pooint");
    console.dir(this.$localStorage);
    //this.currentUser = this.$localStorage.logged_user;
    this.currentUser = this.$auth.getUserData();
    this.showPostScroll = false;
    this.showNoti = false;
    this.$location = $location;
    this.googleMapKey = this.$auth.$env.EnvironmentConfig.mapsKey;
    this.fullGoogleUrl = "https://maps.googleapis.com/maps/api/js?libraries=places&key=" + this.googleMapKey;
    this.adminCheck();

    var _this = this;

    $rootScope.$watch("$routeChangeStart", function () {
      _this.setActiveClass();
      if (!_this.$state.$current.url.sourcePath.includes("messages")) {
        _this.$rootScope.activeMessages = [];
        _this.$rootScope.activeChannel = undefined;
      }
    });

    if (!this.$rootScope.googleHasLoaded) {
      this.$rootScope.googleHasLoaded = true;
    }

    _this.showNotiListener = _this.$rootScope.$on("ShowNoti", function ($event, params) {
      _this.showNoti = true;
      _this.$timeout(function () {
        _this.showNoti = false;
      }, 2000);
    });

    _this.updateCurrentUserListener = _this.$rootScope.$on("UpdateCurrentUser", function (event, params) {
      _this.updateCurrentUser(params);
    });

    _this.autoSaveListener = _this.$rootScope.$on("AutoSave", function (event, params) {
      _this.showAuto = true;
      _this.autoSaveEventAsDraft(params);
    });

    _this.autoSaveListenerTrigger = _this.$rootScope.$on("AutoSaveTrigger", function (event, params) {
      if (params.pop === "on") {
        _this.showAuto = true;
      } else {
        _this.showAuto = false;
      }
    });

    _this.channelsHaveBeenLoadedListener = _this.$rootScope.$on("channelsHaveBeenLoaded", function ($event, params) {
      _this.$timeout(function () {
        _this.$rootScope.channelsHaveLoaded = true;
      });
    });

    _this.SetProfilePictureListener = _this.$rootScope.$on("SetProfilePictureCompany", function ($event, params) {
      _this.currentUser.company.companyLogoUri = params.picture;
    });

    _this.ToastMessageListener = _this.$rootScope.$on("ToastMessage", function ($event, params) {
      _this.toastMessage(params);
    });

    _this.SetNewUserForJobBoardHeaderListener = _this.$rootScope.$on("SetNewUserForJobBoardHeader", function ($event, params) {
      _this.$timeout(function () {
        _this.currentUser = params.user;
        _this.$localStorage.logged_user = params.user;
      });
    });

    _this.SetApplyConfirmationListener = _this.$rootScope.$on("SetApplyConfirmation", function ($event, data) {
      _this.setApplicationStatus(data.params, data.user_not_verified);
    });

    _this.SignUserOutListener = _this.$rootScope.$on("SignUserOutHeader", function (event, params) {
      console.log("_this.SignUserOutHeader");
      _this.signOut();
    });

    _this.SetEventsToScrollerListener = _this.$rootScope.$on("SetEventsToScroller", function (event, params) {
      _this.setToDirective(params);
    });

    _this.GetLogoListener = _this.$rootScope.$on("GetLogo", function (event, params) {
      _this.get_logo(params);
    });

    _this.$scope.$on("$destroy", _this.GetLogoListener);
    _this.$scope.$on("$destroy", _this.SetEventsToScrollerListener);
    _this.$scope.$on("$destroy", _this.SetApplyConfirmationListener);
    _this.$scope.$on("$destroy", _this.SetNewUserForJobBoardHeaderListener);
    _this.$scope.$on("$destroy", _this.showNotiListener);
    _this.$scope.$on("$destroy", _this.autoSaveListener);
    _this.$scope.$on("$destroy", _this.autoSaveListenerTrigger);
    _this.$scope.$on("$destroy", _this.channelsHaveBeenLoadedListener);
    _this.$scope.$on("$destroy", _this.SetProfilePictureListener);
    _this.$scope.$on("$destroy", _this.ToastMessageListener);
    _this.$scope.$on("$destroy", _this.updateCurrentUserListener);
    _this.$scope.$on("$destroy", _this.SignUserOutListener);

    if (!this.$security.isUndefinedOrNull(this.currentUser)) {
      if (this.currentUser.company && this.currentUser.company.id) {
        if (this.$security.isUndefinedOrNull(this.$rootScope.messagingHasBeenInitiated)) {
          _this.$timeout(function () {
            _this.$rootScope.messagingHasBeenInitiated = true;
            _this.$rootScope.channelsHaveLoaded = false;
            _this.$messagingv2.initPubnub();
            _this.remain_loading_count = 0;
            _this.$messagingv2.getChannelsv1(0).then(
              function (response) {
                _this.$messagingv2.initv1(response.data);
              },
              function (data) {
                _this.jobble_types = [];
                _this.remain_loading_count--;
                if (data.status === 401) {
                  _this.$state.go("signin");
                } else {
                  _this.$timeout(function () {
                    //jQuery('#show-application-alert').trigger('click');
                  }, 100);
                }
              }
            );
          });
        }

        if (
          this.$security.isUndefinedOrNull(this.currentUser.company.companyLogoUri) &&
          this.$security.isUndefinedOrNull(this.$rootScope.companyLogoUri)
        ) {
          this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
          let u = this.currentUser;
          this.get_logo(u, "do_not_reload");
        } else {
          if (this.currentUser.company.companyLogoUri) {
            this.$rootScope.companyLogoUri = this.currentUser.company.companyLogoUri;
            this.currentUser.companyProfilePictureUrl = this.currentUser.company.companyLogoUri;
            this.get_logo(this.currentUser);
          }
        }
        this.isJobSeeker = false;
        _this.setTeamsToSession();
        _this.setJobbleTypesToSession();
      } else {
        this.isJobSeeker = true;
        this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
      }
    } else {
      this.$rootScope.channelsHaveLoaded = true;
      this.$rootScope.companyLogoUri = "/app/vendor/images/user-more.png";
      _this.initUnregisteredUser();
    }
  }

  slideToggle() {
    var _this = this;
    if (_this.isJobSeeker) {
      _this.$timeout(function () {
        $(".mobile-menu-wrap").show();
      });
    } else {
      _this.$timeout(function () {
        $(".mobile-menu-wrap").show();
      });
    }
  }

  closeSideBar() {
    var _this = this;
    _this.$timeout(function () {
      $(".mobile-menu-wrap").hide();
    });
  }

  get_logo(user, msg) {
    var _this = this;

    if (_this.currentUser) {
      _this.updateCurrentUser();
    }

    _this.$auth.grab_company_logo(user.access_token).then(
      function (response) {
        let logo = response.data.company.companyLogoUriFree;
        _this.set_logo_to_header(logo);
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetLogoToEventsPage", logo);
        });
      },
      function (error) {}
    );
  }

  set_logo_to_header(logo) {
    var _this = this;
    _this.$timeout(function () {
      if (_this.currentUser) {
        _this.currentUser.company.companyLogoUri = logo;
        _this.$rootScope.companyLogoUri = logo;
        _this.currentUser.companyProfilePictureUrl = logo;
      }
    }, 300);
  }

  updateCurrentUser(params) {
    var _this = this;
    if (params) {
      _this.$timeout(function () {
        _this.currentUser = params.user;
        _this.$localStorage.logged_user = params.user;
        if (_this.$rootScope.channels) {
          _this.$rootScope.channelsHaveLoaded = true;
        }
        if (_this.currentUser.company && _this.currentUser.company.id) {
          _this.isJobSeeker = false;
        } else {
          _this.isJobSeeker = true;
        }
      }, 300);
    }
  }

  signOut() {
    var _this = this;
    this.$auth.signOut().then(function (response) {
      _this.$timeout(function () {
        _this.$tracking.reportUserLogout(_this.$localStorage.logged_user);
        _this.$localStorage.logged_user = null;
        _this.$rootScope.channels = undefined;
        _this.$rootScope.companyLogoUri = undefined;
        _this.$rootScope.inboxLink = undefined;
        _this.$rootScope.channelsHaveLoaded = undefined;
        _this.$rootScope.teams = undefined;
        _this.$rootScope.teamsSimple = undefined;
        _this.$rootScope.globalParams = undefined;
        _this.$rootScope.imgFromProfilePage = undefined;
        _this.$rootScope.jobbleTypes = undefined;
        _this.$rootScope.jobs = undefined;
        _this.$rootScope.jobsSeenOnce = undefined;
        _this.$rootScope.boardParameters = null;
        _this.$messagingv2.setHandleLastMessageDataCounter(0);
        _this.$messagingv2.setTotalAmountOfMissedMessages(0);

        _this.$state.go("signin");
      });
    });
  }

  goToSomeChat(event) {
    var _this = this;
    var missedMessagesFound = false;
    var channelToGoToInURL = undefined;
    try {
      for (var i = 0; i < event.channelArrayHolder.length; i++) {
        if (event.channelArrayHolder[i].missedMessagesCount > 0) {
          missedMessagesFound = true;
          channelToGoToInURL = event.channelArrayHolder[i].name;
          break;
        }
      }
    } finally {
      if (missedMessagesFound) {
        this.$location.path("/messages/event/" + event.eventId).search({c: channelToGoToInURL});
      } else {
        this.$location.path("/messages/event/" + event.eventId);
      }
    }
  }

  inboxLink() {
    var _this = this;
    if (_this.$rootScope.channelsHaveLoaded && !_this.$rootScope.channels) {
      alert("This account has no active messages. If you think there are active messages please refresh the page.");
    } else {
      _this.$timeout(function () {
        _this.$state.go("inbox");
      });
    }
  }

  toastMessage(params) {
    var _this = this;
    var msg = params.m.messagePayload.message;
    if (msg.length > 75) {
      msg = msg.substring(0, 99);
      msg = msg + " ...";
    }
    _this.notMsg = msg;
    _this.notUser = params.m.messagePayload.username;
    _this.notImage = params.m.messagePayload.userProfileImage;
    _this.notChan = params.channel;
    _this.notEventId = params.m.messagePayload.eventId;
    _this.$timeout(function () {
      jQuery("#notification-tab").show("fast");
    });
  }

  closeNotification(eventId, channel) {
    var _this = this;
    _this.$timeout(function () {
      jQuery("#notification-tab").hide("fast");
    });
  }

  goToChat(eventId, channel) {
    var _this = this;
    if (eventId) {
      _this.$location.path("/messages/event/" + eventId).search({c: channel});
    } else {
      return;
    }
  }

  setJobbleTypesToSession() {
    var _this = this;
    if (!_this.$rootScope.jobble_types) {
      _this.loadJobbleTypes();
    }
  }

  loadJobbleTypes() {
    var _this = this;

    _this.$auth.getJobbleTypes().then(
      function (data) {
        _this.$rootScope.jobble_types = data.data;
        _this.$timeout(function () {
          _this.$rootScope.$emit("SetJobbleTypes", {
            jobbleTypes: data.data,
          });
        });
      },
      function (data) {
        _this.jobbleTypes = [];
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setTeamsToSession() {
    var _this = this;
  }

  loadTeams() {
    var _this = this;
    var teamsSimple = [];
    var teams = [];
    _this.$companies.getTeamsTrim().then(
      function (data) {
        try {
          data.data.forEach(function (team, index) {
            _this.setAvatarImageToUsersOfTeam(team);
            team.firstLoadUsersCount = Math.min(team.users.length, 6);
            if (team.firstLoadUsersCount == 6) {
              team.firstLoadUsersCount = 5;
            }
            teams.push(team);
            var teamsObj = {};
            teamsObj.name = team.name;
            teamsObj.id = team.id;
            teamsSimple.push(teamsObj);
          });
        } finally {
          _this.$timeout(function () {
            _this.$rootScope.teams = teams;
            _this.$rootScope.teamsSimple = teamsSimple;
            _this.$rootScope.$emit("TeamsHaveLoaded", {
              teams: teams,
            });
          });
        }
      },
      function (data) {
        _this.$rootScope.teams = [];
        _this.$timeout(function () {
          jQuery("#show-application-alert").trigger("click");
        }, 100);
      }
    );
  }

  setAvatarImageToUsersOfTeam(team) {
    var _this = this;
    if (team.users) {
      team.users.forEach(function (userProfile) {
        if (!_this.$security.isUndefinedOrNull(userProfile.picture1s)) {
          userProfile.picture1s.forEach(function (pic) {
            if (pic.indexOf("75x75") > -1) {
              userProfile.pictureAvatarUrl = pic;
            }
            if (pic.indexOf("160x160") > -1) {
              userProfile.pictureAvatarUrlBig = pic;
            }
          });
        }
        if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
          userProfile.pictureAvatarUrl = userProfile.pictureAvatarUrlBig;
        }
        if (_this.$security.isUndefinedOrNull(userProfile.pictureAvatarUrl)) {
          userProfile.pictureAvatarUrl = "/app/vendor/images/defaultimg.jpeg";
        }
      });
    }
  }

  closeNoti(x) {
    var _this = this;
    _this.showNoti = false;
    if (x === 2) {
      _this.$timeout(function () {
        jQuery(".modal-backdrop").remove();
        jQuery("body").removeClass("modal-open");
      });
    }
  }

  closeAutoSave(x) {
    var _this = this;
    _this.showAuto = false;
  }

  autoSaveEventAsDraft(params) {
    var _this = this;
    if (params.update) {
      _this.$timeout(function () {
        _this.showAuto = false;
      }, 2000);
    } else {
      if (!params.questions) {
        params.questions = [];
        var p = {
          question: "Are you a good fit?",
          questionType: 1,
          name: "Question 1",
        };
        params.questions.push(p);
      }
      _this.$events.saveDraft(params).then(
        function (response) {
          if (response.data.status === "error") {
            _this.$timeout(function () {
              _this.showAuto = false;
            });
            if (response.data.message.indexOf("Data too long for column 'dress_code'") > -1) {
              alert("The Dress Code on page 1 is too long. Please go back and shorten.");
            } else {
              alert("There was an issue please contact an admin.");
            }
            return;
          }
          _this.$timeout(function () {
            _this.showAuto = false;
            _this.$rootScope.$emit("SetEventIdForDrafting", {
              draftData: response,
            });
          }, 2000);
        },
        function (error) {
          console.log("we are in error");
          console.dir(error);
        }
      );
    }
  }

  logOnboardingTracking(event) {
    var _this = this;
    _this.$tracking.reportOboardingScreenOne(event);
  }

  setActiveClass() {
    var _this = this;
    if (_this.$state.current.url.indexOf("/events") > -1) {
      _this.$timeout(function () {
        jQuery(".pull-right ul li:nth-child(2)").addClass("active");
      });
    }
    if (_this.$state.current.url.indexOf("/transactionhistory") > -1) {
      _this.$timeout(function () {
        jQuery(".pull-right ul li:nth-child(3)").addClass("active");
      });
    }
    if (_this.$state.current.url.indexOf("/teams") > -1) {
      _this.$timeout(function () {
        jQuery(".pull-right ul li:nth-child(4)").addClass("active");
      });
    }
    if (_this.$state.current.url.indexOf("/inbox") > -1) {
      _this.$timeout(function () {
        jQuery(".pull-right ul li:nth-child(5)").addClass("active");
      });
    }
  }

  initUnregisteredUser() {
    var _this = this;
    _this.isJobSeeker = true;
  }

  funnelToMobileApp(x) {
    var _this = this;
    let button = null;
    switch (x) {
      case 1:
        _this.text = "hi";
        button = "Applications";
        break;
      case 2:
        _this.text = "hi";
        button = "Messages";
        break;
      case 3:
        _this.text = "hi";
        button = "Jobs";
        break;
      case 4:
        _this.text = "hi";
        button = "Payments";
        break;
    }
    _this.trackingHeader(button);
  }

  moreInfoModal() {
    var _this = this;
    if (_this.appError) {
      _this.$timeout(function () {
        $(".noti-message-application-error").hide("fast");
      });
    } else {
      _this.$timeout(function () {
        $(".noti-message-application-success").hide("fast");
      });
    }
    _this.$timeout(function () {
      $("#more-application-info").modal();
    }, 500);
  }

  setApplicationStatus(data, user_not_verified) {
    var _this = this;
    if (data.data.status === "error") {
      if (data.data.message === "Applicant already applied for jobble in the pool") {
        _this.applicationText = "You already applied to this job. Please pick another.";
      } else {
        _this.applicationText = "There was an issue with your application. Please try again later.";
      }
      _this.appError = true;
    } else {
      _this.applicationText = "Success! Check your application status on our mobile app.";
      _this.appError = false;
    }
    if (user_not_verified) {
      _this.$timeout(function () {
        $("#finishing-steps").modal();
      }, 300);
    }
    _this.$timeout(function () {
      _this.applicationText = null;
    }, 10000);
  }

  closeNotiApp() {
    var _this = this;
    _this.applicationText = null;
  }

  trackingHeader(button) {
    var _this = this;
    let data = {};
    if (!_this.currentUser) {
      data.username = "Unregistered";
    } else {
      data.username = _this.currentUser.username;
    }
    data.button = button;
    _this.$tracking.reportHeaderClicks(button);
  }

  goToProfile() {
    var _this = this;
  }

  goToEvents() {
    var _this = this;
    _this.$state.go("events");
  }

  showPostBlur() {
    var _this = this;
    _this.$timeout(function () {
      $(".hidden-drop-down-post-types").hide("slide", {direction: "up"}, 100);
      _this.showPostScroll = false;
    }, 300);
  }

  showPostScrollFunc() {
    var _this = this;
    let dropdown = _this.currentUser.company.postingTypesAllowed;
    if (dropdown === 0) {
      if (_this.showPostScroll === false) {
        _this.$timeout(function () {
          _this.showPostScroll = true;
          $(".hidden-drop-down-post-types").show("slide", {direction: "up"}, 100);
        });
      } else {
        _this.$timeout(function () {
          _this.showPostScroll = false;
          $(".hidden-drop-down-post-types").hide("slide", {direction: "up"}, 100);
        });
      }
    } else {
      _this.$state.go("postevent");
    }
  }

  showJobScroll() {
    var _this = this;
    let showList = null;

    if (_this.showJobsDropDown === false) {
      _this.$timeout(function () {
        _this.$rootScope.$emit("ListEventsForScroll", {});
        _this.showJobsDropDown = true;
        $(".hidden-drop-down").show("slide", {direction: "up"}, 100);
      });
    } else {
      _this.$timeout(function () {
        _this.showJobsDropDown = false;
        $(".hidden-drop-down").hide("slide", {direction: "up"}, 100);
      });
    }
  }

  showDropDownList() {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("ListEventsForScroll", {});
      $(".hidden-drop-down").show("fast");
    });
    _this.showJobsDropDown = true;
  }

  setToDirective(params) {
    var _this = this;
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetEventsToJobsScroll", {params});
    });
  }

  jobDropDownBlur() {
    var _this = this;
    _this.$timeout(function () {
      $(".hidden-drop-down").hide("slide", {direction: "up"}, 100);
      _this.showJobsDropDown = false;
    }, 300);
  }

  jobDropDownFocus() {
    var _this = this;
  }

  jobDropDownHover() {
    var _this = this;
    _this.showJobScroll();
  }

  jobDropDownLeave() {
    var _this = this;
    _this.showJobScroll();
  }

  reportHeaderDropDownClick(link) {
    var _this = this;
    let data = {};
    if (_this.currentUser) {
      data.user = _this.currentUser.email;
    } else {
      data.user = "Unregistered";
    }
    switch (link) {
      case 1:
        data.button = "Account";
        return;
      case 2:
        data.button = "Direct Pay";
        return;
      case 3:
        data.button = "Help Center";
        return;
      case 4:
        data.button = "Logout";
        return;
    }
    _this.$tracking.reportHeaderMenuInteraction(data);
  }

  send_to_basic_profile() {
    var _this = this;
    _this.$timeout(function () {
      $("#finishing-steps").modal("toggle");
    });
    _this.$timeout(function () {
      _this.$state.go("jobbler", {});
    }, 300);
  }

  checkAccountType() {
    var _this = this;
    let cid = _this.currentUser.company.id;
    if (cid) {
      if (_this.currentUser.company.industryType) {
        let industry_type_id = _this.currentUser.company.industryType.id;
        if (industry_type_id) {
          _this.currentUser.company.industry = "Delivery";
        } else {
          console.log("we do not have an industry type");
        }
      }
    }
  }

  rotate() {
    var _this = this;
    _this.$timeout(function () {
      $(".main-menu ul li a i").toggleClass("down");
    });
  }

  redirectUser() {
    var _this = this;
  }
}

JobbleheaderController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "auth",
  "security",
  "tracking",
  "$rootScope",
  "$scope",
  "$location",
  "$timeout",
  "$window",
  "companies",
  "messagingv2",
  "events",
];

export default JobbleheaderController;



// WEBPACK FOOTER //
// ./client/app/common/jobbleheader/jobbleheader.controller.js